<template>
    <div>
     <!-- <section class="menu " v-bind:class="{'is-fixed-custom': isFixed}"> -->
     <section class="menu is-fixed-custom" >
      <div class="fullwidth container" >
        <div class="columns">
          <div class="column is-12-fullhd ">
             <nav class="navbar" id="navbarfull" role="navigation" aria-label="main navigation" style="height: 70px;">
                  <div class="navbar-brand">
                    <router-link :to="'/' + $i18n.locale" class="navbar-item">
                        <!-- <img src="../assets/images/logo_dark.png" width="117px" heigth="94px"> -->
                    </router-link>
                    <a role="button" @click="ActivateMobileMenu" class="navbar-burger burger-is-large" aria-label="menu" aria-expanded="false" data-target="navbar">
                      <span aria-hidden="true"></span>
                      <span aria-hidden="true"></span>
                      <span aria-hidden="true"></span>
                    </a>
                  </div>
                  <div id="navbar" class="navbar-menu" :class="{'is-active': mobilemenushow}">

                    <div class="navbar-end">

                      <router-link  @click.native="ActivateMobileMenu" :to="'/' + $i18n.locale" class="navbar-item">
                        {{texts.homepage}}
                      </router-link>
                      <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale +'/#aboutus'" v-scroll-to="'#aboutus'" class="navbar-item">
                        {{texts.aboutus}}
                      </router-link>
                       <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale +'/#products'" v-scroll-to="'#products'" class="navbar-item">
                        {{texts.products}}
                      </router-link>
                       <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale +'/#service'" v-scroll-to="'#service'" class="navbar-item">
                        {{texts.service}}
                      </router-link>
                       <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale+'/faq'" class="navbar-item">
                        {{texts.faq}}
                      </router-link>
                       <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale+'/contact'" class="navbar-item">
                        {{texts.contacts}}
                      </router-link>
                       <div class="language-bar-navbar  is-flex is-align-items-center">
                          <button class="circle-button" v-bind:class="{ active: $i18n.locale=='en' }" @click="ChangeLocale('en')">EN</button> 
                          <button class="circle-button" v-bind:class="{ active: $i18n.locale=='ro' }" @click="ChangeLocale('ro')">RO</button>
                          <button class="circle-button" v-bind:class="{ active: $i18n.locale=='hu' }" @click="ChangeLocale('hu')">HU</button>
                      </div>
                    </div>
                   
                  </div>
                                   
             </nav>      
           </div>
         </div>
     </div>
    </section>
    <!-- <section class="menu menu-placeholder" v-bind:class="{'menu-placeholder-active': isFixed}"> -->
    <section class="menu menu-placeholder menu-placeholder-active" >
      <div class="fullwidth container">
        <div class="columns">
          <div class="column is-12-fullhd ">
             <nav class="navbar" id="navbarfull" role="navigation" aria-label="main navigation" style="height: 70px;">
                  <div class="navbar-brand">
                    <router-link :to="'/' + $i18n.locale" class="navbar-item">

                        <!-- <img src="../assets/images/logo_dark.png" width="117px" heigth="94px"> -->
                    </router-link>
                    <a role="button" @click="ActivateMobileMenu" class="navbar-burger burger-is-large" aria-label="menu" aria-expanded="false" data-target="navbar">
                      <span aria-hidden="true"></span>
                      <span aria-hidden="true"></span>
                      <span aria-hidden="true"></span>
                    </a>
                  </div>
                  <div id="navbar" class="navbar-menu" :class="{'is-active': mobilemenushow}">

                    <div class="navbar-end">

                      <router-link  @click.native="ActivateMobileMenu" :to="'/' + $i18n.locale" class="navbar-item">
                        {{texts.homepage}}
                      </router-link>
                      <router-link  v-on:click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale +'/#aboutus'" v-scroll-to="'#aboutus'" class="navbar-item">
                        {{texts.aboutus}}
                      </router-link>
                       <router-link  v-on:click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale +'/#products'" v-scroll-to="'#products'" class="navbar-item">
                        {{texts.products}}
                      </router-link>
                      <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale +'/#service'" v-scroll-to="'#service'" class="navbar-item">
                        {{texts.service}}
                      </router-link>
                       <router-link  @click.native="ActivateMobileMenu" :to="'/'+ $i18n.locale+'/faq'" class="navbar-item">
                        {{texts.faq}}
                      </router-link>
                      
                       <router-link  v-on:click.native="ActivateMobileMenu" to="" v-scroll-to="'#footer'" class="navbar-item">
                        {{texts.contacts}}
                      </router-link>
                      
                    </div>
                    </div>
                                   
             </nav>      
           </div>
         </div>
     </div>
    </section>
    </div>
</template>
<script>
import { constants } from 'crypto';
// window.onscroll = function (e) {
//   if(window.scrollY>screen.height){
//   }
// };
export default {
  
  data(){
    return{
      mobilemenushow:false,
      isFixed:false
    }
  },
  computed:{
    texts(){
      return this.$t("navbar")
    }
  },
  methods:{
    ActivateMobileMenu(){
      this.mobilemenushow=!this.mobilemenushow
    },
    handleScroll (event) {
      let str = this.$route.path
      var res = str.split("/");
      var lastRes = res[res.length-1]
      this.isFixed = true;
      // if(lastRes == 'goodtransport' || lastRes == 'mobilehouse' || lastRes == 'boat' || lastRes == 'faq'){
      //   this.isFixed = true;
      // }
      // else {
      //   if(window.scrollY>window.innerHeight){
      //     this.isFixed = true;
      //   } else(this.isFixed = false)
      // }
    },
    ChangeLocale(lang){
      this.$i18n.locale = lang;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
.navbar >.container{
 max-width: 85%;
}
.menu-placeholder{
  display: none;
}
.menu-placeholder-active{
  display: block;
  position: relative;
  top: 0px;
}
.navbar-end{
  a.navbar-item{
    padding: 8px 17px;
    transition: 0.10s ease-out;
    padding: 8px 10px;
    color: $primary;
    font-weight: 700;
    font-size: .95rem;
    text-transform: uppercase;
    color:  #09404a;
    @media (max-width: 1024px) {
      padding: 8px 30px;
    }

  }
  a.navbar-item:hover{
    transform-origin: center 58%;
    transition: 0.10s ease-out;
    transform: scale(1.05);
  }
}
.hero-head .navbar {
	padding-top: 2rem;
}
.menu{
  padding: 10px 0 10px 0;
}
.is-fixed-custom{
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 1000;
  padding-bottom: 0; 
}
.is-fixed-custom::after{
  display: none
}
.menu:after {
	height:7px;
	display:block;
	background: linear-gradient(to bottom, #e9e9e9, #fff);
	content: "";
	width: 100%;
}
.navbar >.container{
 max-width: 85%;
}
.navbar-brand{
  padding-left:20px;
}
.navbar-end{
  a.navbar-item{
    background-color:transparent; 
  }
}
.hero-body .container{
  max-width: 55%;
}
.hero-foot{
  min-height: 142px;
}

.navbar-item img{
    max-height: 6em!important;
}
.hero-body h1,
.hero-body h2,
.hero-body h3{
	color: #000;
}
.hero-head .navbar {
	padding-top: 2rem;
}
.menu:after {
	height:7px;
	display:block;
	background: linear-gradient(to bottom, #e9e9e9, #fff);
	content: "";
	width: 100%;
}

.hero-foot .column {
	text-align: center;
	margin-bottom: 1rem;
}
.hebo{
	color: #cfdbd6;
}
.trailers {
	color: #ef6d22;
	font-style:italic;
}
.menu .columns{
    margin:0;
    .column{
      padding: 0;
      .navbar-item{
        margin: 0 1.3%;
      }
    }
}

.language-bar-navbar {
  align-items: center;
  margin: 0 1.3%;
  @media (max-width: 1024px) {
    padding: 8px 27px;
  }
  

  button{
    cursor: pointer;
    font-size: .95rem;
    color: #09404a;
  }
  button.active {
    color: white;
  }
  button:hover {
    -webkit-transform-origin: center 58%;
    transform-origin: center 58%;
    -webkit-transition: 0.10s ease-out;
    transition: 0.10s ease-out;
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
}
</style>

